module.exports = __webpack_public_path__ + "static/media/loading-spin.9362411c.svg";